// production.js
const config = {
  API_URL: "https://faapi.diproit.com/api",
  FEATURE_TOGGLE: false,
};

export default config;
